/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateBrandGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type CreateBrandRequest = {
  accountID: string;
  brandProperties: components.BrandProperties;
};

export type CreateBrandResponse = {
  headers: { [k: string]: Array<string> };
  result: components.BrandProperties;
};

/** @internal */
export const CreateBrandGlobals$inboundSchema: z.ZodType<
  CreateBrandGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type CreateBrandGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const CreateBrandGlobals$outboundSchema: z.ZodType<
  CreateBrandGlobals$Outbound,
  z.ZodTypeDef,
  CreateBrandGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function createBrandGlobalsToJSON(
  createBrandGlobals: CreateBrandGlobals,
): string {
  return JSON.stringify(
    CreateBrandGlobals$outboundSchema.parse(createBrandGlobals),
  );
}
export function createBrandGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<CreateBrandGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateBrandGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateBrandGlobals' from JSON`,
  );
}

/** @internal */
export const CreateBrandRequest$inboundSchema: z.ZodType<
  CreateBrandRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  BrandProperties: components.BrandProperties$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "BrandProperties": "brandProperties",
  });
});
/** @internal */
export type CreateBrandRequest$Outbound = {
  accountID: string;
  BrandProperties: components.BrandProperties$Outbound;
};

/** @internal */
export const CreateBrandRequest$outboundSchema: z.ZodType<
  CreateBrandRequest$Outbound,
  z.ZodTypeDef,
  CreateBrandRequest
> = z.object({
  accountID: z.string(),
  brandProperties: components.BrandProperties$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    brandProperties: "BrandProperties",
  });
});

export function createBrandRequestToJSON(
  createBrandRequest: CreateBrandRequest,
): string {
  return JSON.stringify(
    CreateBrandRequest$outboundSchema.parse(createBrandRequest),
  );
}
export function createBrandRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateBrandRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateBrandRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateBrandRequest' from JSON`,
  );
}

/** @internal */
export const CreateBrandResponse$inboundSchema: z.ZodType<
  CreateBrandResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.BrandProperties$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type CreateBrandResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.BrandProperties$Outbound;
};

/** @internal */
export const CreateBrandResponse$outboundSchema: z.ZodType<
  CreateBrandResponse$Outbound,
  z.ZodTypeDef,
  CreateBrandResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.BrandProperties$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function createBrandResponseToJSON(
  createBrandResponse: CreateBrandResponse,
): string {
  return JSON.stringify(
    CreateBrandResponse$outboundSchema.parse(createBrandResponse),
  );
}
export function createBrandResponseFromJSON(
  jsonString: string,
): SafeParseResult<CreateBrandResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateBrandResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateBrandResponse' from JSON`,
  );
}
